<!--人员管理-->
<template>
  <div class="trialScGlIndexClass">
    <div>
      <nav-com activeIndex="3"></nav-com>
    </div>

    <div style="padding: 15px">
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                <el-form-item label="小区名称： ">
                  <el-input
                    placeholder="请输入小区名称..."
                    v-model="search.COMPANY_NAME"
                  ></el-input>
                  <label style="margin-left:6px;">经纪人姓名：</label>
                  <el-input
                    placeholder="请输入姓名..."
                    v-model="search.AGENT_NAME"
                  ></el-input>
                  <label style="margin-left:6px;">经纪人手机号：</label>
                  <el-input
                    placeholder="请输入手机号..."
                    v-model="search.AGENT_PHONE"
                  ></el-input>
                  <label style="margin-left:6px;">佣金状态：</label>
                  <el-select
                    placeholder="请选择"
                    v-model="search.COMMISSION_STATUS"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未结佣" value="0"></el-option>
                    <el-option label="已结佣" value="1"></el-option>
                  </el-select>
                  <el-button
                    type="success"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    综合查询
                  </el-button>
                  <div style="float:right;margin-right:10px;">
                    <upload-curr-com
                      :mainLoadData="mainLoad"
                      :op="op"
                      :paramData="search"
                      :tableColumns="tableColumns"
                      mbBtnTxt="导出财务报表"
                      isUpLoadBtn="0"
                      isDownBtn="1"
                    ></upload-curr-com>
                  </div>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- table列表  开始 -->

      <div style="position: relative;">
        <el-table
          height="80vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="操作" width="280">
            <template slot-scope="scope">
              <el-button
                v-if="false"
                @click="openCommissionDialog(scope.row)"
                type="text"
                size="small"
                :style="{
                  color:
                    scope.row.COMMISSION_STATUS === '1' ? '#67C23A' : '#E6A23C'
                }"
              >
                {{
                  scope.row.COMMISSION_STATUS === "1" ? "查看结佣" : "修改结佣"
                }}
              </el-button>
              <el-button
                v-if="
                  scope.row.COMMISSION_AMOUNT &&
                    parseFloat(scope.row.COMMISSION_AMOUNT) > 0
                "
                @click="openCommissionPayDialog(scope.row)"
                type="text"
                size="small"
                style="color: #409EFF"
              >
                经纪人佣金确认发放
              </el-button>
              <el-button
                v-if="
                  scope.row.DEAL_PRICE && parseFloat(scope.row.DEAL_PRICE) > 0
                "
                @click="openFinalPaymentDialog(scope.row)"
                type="text"
                size="small"
                style="color: #E6A23C"
              >
                房源尾款确认打款
              </el-button>
            </template>
          </el-table-column>
          <template v-for="(col, index) in tableColumns">
            <el-table-column
              :prop="col.colName"
              :label="col.colText"
              :key="index"
              v-if="col.colShow"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    col.colName === 'COMMISSION_STATUS' ||
                      col.colName === 'HAS_KEY' ||
                      col.colName === 'DEAL_STATUS' ||
                      col.colName === 'DEAL_DATETIME' ||
                      col.colName === 'ISPAYMENT' ||
                      col.colName === 'PAYMENTTM' ||
                      col.colName === 'DEPOSIT_VOUCHER_IMAGES' ||
                      col.colName === 'COMMISSION_VOUCHER_IMAGES' ||
                      col.colName === 'BALANCE_AMOUNT' ||
                      col.colName === 'DEPOSIT_DATE' ||
                      col.colName === 'COMMISSION_DATE' ||
                      col.colName === 'KEY_RECEIVE_DATE' ||
                      col.colName === 'KEY_CANCEL_DATE' ||
                      col.colName === 'CREATE_TIME' ||
                      col.colName === 'UPDATE_TIME'
                  "
                >
                  <div v-if="col.colName === 'COMMISSION_STATUS'">
                    <el-tag
                      :type="
                        scope.row.COMMISSION_STATUS === '1' ? 'success' : 'info'
                      "
                      size="small"
                    >
                      {{
                        scope.row.COMMISSION_STATUS === "1"
                          ? "已结佣"
                          : "未结佣"
                      }}
                    </el-tag>
                  </div>
                  <div v-else-if="col.colName === 'DEAL_STATUS'">
                    <span
                      v-if="scope.row.DEAL_STATUS === '1'"
                      style="color:green;font-weight:bold"
                      >已成交</span
                    >
                    <span
                      v-if="scope.row.DEAL_STATUS === '2'"
                      style="color:red;font-weight:bold"
                      >未成交</span
                    >
                  </div>
                  <div v-else-if="col.colName === 'DEAL_DATETIME'">
                    {{
                      formatDateTime(scope.row.DEAL_DATE, scope.row.DEAL_TIME)
                    }}
                  </div>
                  <div v-else-if="col.colName === 'ISPAYMENT'">
                    <el-tag
                      :type="
                        scope.row.ISPAYMENT === '1' ? 'success' : 'warning'
                      "
                      size="small"
                    >
                      {{ scope.row.ISPAYMENT === "1" ? "已结算" : "未结算" }}
                    </el-tag>
                  </div>
                  <div v-else-if="col.colName === 'PAYMENTTM'">
                    {{ formatStandardDateTime(scope.row.PAYMENTTM) }}
                  </div>
                  <div v-else-if="col.colName === 'DEPOSIT_DATE'">
                    {{ formatStandardDateTime(scope.row.DEPOSIT_DATE) }}
                  </div>
                  <div v-else-if="col.colName === 'COMMISSION_DATE'">
                    {{ formatStandardDateTime(scope.row.COMMISSION_DATE) }}
                  </div>
                  <div v-else-if="col.colName === 'KEY_RECEIVE_DATE'">
                    {{ formatStandardDateTime(scope.row.KEY_RECEIVE_DATE) }}
                  </div>
                  <div v-else-if="col.colName === 'KEY_CANCEL_DATE'">
                    {{ formatStandardDateTime(scope.row.KEY_CANCEL_DATE) }}
                  </div>
                  <div v-else-if="col.colName === 'CREATE_TIME'">
                    {{ formatStandardDateTime(scope.row.CREATE_TIME) }}
                  </div>
                  <div v-else-if="col.colName === 'UPDATE_TIME'">
                    {{ formatStandardDateTime(scope.row.UPDATE_TIME) }}
                  </div>
                  <div v-else-if="col.colName === 'BALANCE_AMOUNT'">
                    {{
                      calculateBalanceAmount(
                        scope.row.DEAL_PRICE,
                        scope.row.DEPOSIT_AMOUNT
                      )
                    }}
                  </div>
                  <div v-else-if="col.colName === 'DEPOSIT_VOUCHER_IMAGES'">
                    <a
                      v-if="getImageCount(scope.row.DEPOSIT_VOUCHER_IMAGES) > 0"
                      href="javascript:void(0);"
                      @click="
                        openImageDialog(
                          scope.row.DEPOSIT_VOUCHER_IMAGES,
                          '定金凭证'
                        )
                      "
                      style="color: #409EFF; text-decoration: none; cursor: pointer;"
                    >
                      查看图片({{
                        getImageCount(scope.row.DEPOSIT_VOUCHER_IMAGES)
                      }})
                    </a>
                    <span v-else style="color: #909399;">无</span>
                  </div>
                  <div v-else-if="col.colName === 'COMMISSION_VOUCHER_IMAGES'">
                    <a
                      v-if="
                        getImageCount(scope.row.COMMISSION_VOUCHER_IMAGES) > 0
                      "
                      href="javascript:void(0);"
                      @click="
                        openImageDialog(
                          scope.row.COMMISSION_VOUCHER_IMAGES,
                          '佣金凭证'
                        )
                      "
                      style="color: #67C23A; text-decoration: none; cursor: pointer;"
                    >
                      查看图片({{
                        getImageCount(scope.row.COMMISSION_VOUCHER_IMAGES)
                      }})
                    </a>
                    <span v-else style="color: #909399;">无</span>
                  </div>
                  <div v-else>
                    <span v-if="scope.row.HAS_KEY === '0'" style="color:red"
                      >否</span
                    >
                    <span v-if="scope.row.HAS_KEY === '1'" style="color:green"
                      >是</span
                    >
                  </div>
                </div>
                <div v-else>
                  {{ scope.row[col.colName] }}
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div style="float: right;margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>

      <!-- table列表  结束 -->

      <!-- 结佣对话框 开始 -->
      <el-dialog
        :title="commissionDialog.isView ? '查看结佣信息' : '修改结佣状态'"
        :visible.sync="commissionDialog.visible"
        width="600px"
      >
        <el-form :model="commissionDialog.row" label-width="120px">
          <el-form-item label="成交单号">
            <el-input
              v-model="commissionDialog.row.DEAL_ID"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="经纪人姓名">
            <el-input
              v-model="commissionDialog.row.AGENT_NAME"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="经纪人电话">
            <el-input
              v-model="commissionDialog.row.AGENT_PHONE"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="佣金金额（元）">
            <el-input
              v-model="commissionDialog.row.COMMISSION_AMOUNT"
              type="number"
              :disabled="commissionDialog.isView"
              placeholder="请输入佣金金额"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="结佣时间">
            <el-date-picker
              v-model="commissionDialog.row.COMMISSION_DATE"
              type="datetime"
              placeholder="选择结佣时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
              :disabled="commissionDialog.isView"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="commissionDialog.visible = false">{{
            commissionDialog.isView ? "关闭" : "取消"
          }}</el-button>
          <el-button
            type="primary"
            @click="saveCommission"
            v-if="!commissionDialog.isView"
            >确定提交</el-button
          >
        </div>
      </el-dialog>
      <!-- 结佣对话框 结束 -->

      <!-- 经纪人佣金确认发放对话框 开始 -->
      <el-dialog
        title="经纪人佣金确认发放"
        :visible.sync="commissionPayDialog.visible"
        width="600px"
      >
        <el-form :model="commissionPayDialog.row" label-width="140px">
          <el-form-item label="成交单号">
            <el-input
              v-model="commissionPayDialog.row.DEAL_ID"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="经纪人姓名">
            <el-input
              v-model="commissionPayDialog.row.AGENT_NAME"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="经纪人电话">
            <el-input
              v-model="commissionPayDialog.row.AGENT_PHONE"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="佣金金额（元）">
            <el-input
              v-model="commissionPayDialog.row.COMMISSION_AMOUNT"
              type="number"
              placeholder="请输入佣金金额"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="佣金备注">
            <el-input
              v-model="commissionPayDialog.row.COMMISSION_REMARK"
              type="textarea"
              :rows="3"
              placeholder="请输入佣金备注"
            ></el-input>
          </el-form-item>
          <el-form-item label="已付佣金凭证图片">
            <el-input
              v-model="commissionPayDialog.row.COMMISSION_VOUCHER_IMAGES"
              type="textarea"
              :rows="2"
              placeholder="请输入图片URL，多个用逗号分隔"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="凭证图片预览"
            v-if="
              getImageCount(commissionPayDialog.row.COMMISSION_VOUCHER_IMAGES) >
                0
            "
          >
            <div style="display: flex; flex-wrap: wrap; gap: 10px;">
              <div
                v-for="(img, index) in parseImages(
                  commissionPayDialog.row.COMMISSION_VOUCHER_IMAGES
                )"
                :key="index"
                style="width: 100px; height: 100px;"
              >
                <el-image
                  :src="img"
                  :preview-src-list="
                    parseImages(
                      commissionPayDialog.row.COMMISSION_VOUCHER_IMAGES
                    )
                  "
                  fit="cover"
                  style="width: 100%; height: 100%; cursor: pointer; border-radius: 4px; border: 1px solid #dcdfe6;"
                >
                  <div
                    slot="error"
                    style="display: flex; justify-content: center; align-items: center; height: 100%; background: #f5f7fa; color: #909399;"
                  >
                    <i
                      class="el-icon-picture-outline"
                      style="font-size: 24px;"
                    ></i>
                  </div>
                </el-image>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="commissionPayDialog.visible = false"
            >取消</el-button
          >
          <el-button type="primary" @click="saveCommissionPay"
            >确定发放</el-button
          >
        </div>
      </el-dialog>
      <!-- 经纪人佣金确认发放对话框 结束 -->

      <!-- 房源尾款确认打款对话框 开始 -->
      <el-dialog
        title="房源尾款确认打款"
        :visible.sync="finalPaymentDialog.visible"
        width="600px"
      >
        <el-form :model="finalPaymentDialog.row" label-width="140px">
          <el-form-item label="成交单号">
            <el-input
              v-model="finalPaymentDialog.row.DEAL_ID"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="小区名称">
            <el-input
              v-model="finalPaymentDialog.row.COMMUNITYNAME"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="房源信息">
            <el-input
              :value="
                finalPaymentDialog.row.BUILDING_NO +
                  '栋' +
                  finalPaymentDialog.row.UNIT_NO +
                  '单元' +
                  finalPaymentDialog.row.HOUSE_NO +
                  '号'
              "
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="成交价格（万元）">
            <el-input
              v-model="finalPaymentDialog.row.DEAL_PRICE"
              type="number"
              placeholder="请输入成交价格"
            >
              <template slot="append">万元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="定金金额（元）">
            <el-input
              disabled="true"
              v-model="finalPaymentDialog.row.DEPOSIT_AMOUNT"
              type="number"
              placeholder="请输入定金金额"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="水电物业费（元）">
            <el-input
              v-model="finalPaymentDialog.row.UTILITIESFEE"
              type="number"
              placeholder="请输入水电物业费"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="其他费用（元）">
            <el-input
              v-model="finalPaymentDialog.row.OTHERFEE"
              type="number"
              placeholder="请输入其他费用"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="是否结算">
            <el-select
              v-model="finalPaymentDialog.row.ISPAYMENT"
              style="width:100%"
            >
              <el-option label="已结算" value="1"></el-option>
              <el-option label="未结算" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="尾款结算时间"
            v-if="finalPaymentDialog.row.ISPAYMENT === '1'"
          >
            <el-date-picker
              v-model="finalPaymentDialog.row.PAYMENTTM"
              type="datetime"
              placeholder="选择结算时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="已付定金凭证图片">
            <el-input
              v-model="finalPaymentDialog.row.DEPOSIT_VOUCHER_IMAGES"
              type="textarea"
              :rows="2"
              placeholder="请输入图片URL，多个用逗号分隔"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="凭证图片预览"
            v-if="
              getImageCount(finalPaymentDialog.row.DEPOSIT_VOUCHER_IMAGES) > 0
            "
          >
            <div style="display: flex; flex-wrap: wrap; gap: 10px;">
              <div
                v-for="(img, index) in parseImages(
                  finalPaymentDialog.row.DEPOSIT_VOUCHER_IMAGES
                )"
                :key="index"
                style="width: 100px; height: 100px;"
              >
                <el-image
                  :src="img"
                  :preview-src-list="
                    parseImages(finalPaymentDialog.row.DEPOSIT_VOUCHER_IMAGES)
                  "
                  fit="cover"
                  style="width: 100%; height: 100%; cursor: pointer; border-radius: 4px; border: 1px solid #dcdfe6;"
                >
                  <div
                    slot="error"
                    style="display: flex; justify-content: center; align-items: center; height: 100%; background: #f5f7fa; color: #909399;"
                  >
                    <i
                      class="el-icon-picture-outline"
                      style="font-size: 24px;"
                    ></i>
                  </div>
                </el-image>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="finalPaymentDialog.row.REMARKS"
              type="textarea"
              :rows="3"
              placeholder="请输入备注信息"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="finalPaymentDialog.visible = false"
            >取消</el-button
          >
          <el-button type="primary" @click="saveFinalPayment"
            >确定打款</el-button
          >
        </div>
      </el-dialog>
      <!-- 房源尾款确认打款对话框 结束 -->

      <!-- 图片查看对话框 开始 -->
      <el-dialog
        :title="imageDialog.title"
        :visible.sync="imageDialog.visible"
        width="80%"
        top="5vh"
      >
        <div style="max-height: 70vh; overflow-y: auto;">
          <el-row :gutter="20">
            <el-col
              :span="8"
              v-for="(img, index) in imageDialog.images"
              :key="index"
              style="margin-bottom: 20px;"
            >
              <el-card :body-style="{ padding: '10px' }">
                <el-image
                  :src="img"
                  :preview-src-list="imageDialog.images"
                  fit="cover"
                  style="width: 100%; height: 200px; cursor: pointer;"
                >
                  <div
                    slot="error"
                    style="display: flex; justify-content: center; align-items: center; height: 100%; background: #f5f7fa; color: #909399;"
                  >
                    <i
                      class="el-icon-picture-outline"
                      style="font-size: 40px;"
                    ></i>
                  </div>
                </el-image>
                <div
                  style="text-align: center; margin-top: 10px; font-size: 12px; color: #606266;"
                >
                  图片 {{ index + 1 }}
                </div>
              </el-card>
            </el-col>
          </el-row>
          <div
            v-if="imageDialog.images.length === 0"
            style="text-align: center; padding: 50px; color: #909399;"
          >
            <i class="el-icon-picture-outline" style="font-size: 60px;"></i>
            <div style="margin-top: 10px;">暂无图片</div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="imageDialog.visible = false">关闭</el-button>
        </div>
      </el-dialog>
      <!-- 图片查看对话框 结束 -->
    </div>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
import UploadCurrCom from "../../components/uploadCurrCom/UploadCurrCom.vue";
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "PersonGlIndex",
  components: { NavCom, UploadCurrCom, allParam },
  data() {
    return {
      rows: [],
      action: allParam.downMbUrl,
      objDataParam: "",
      search: {},
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      tableColumns: [
        {
          colName: "DEAL_ID",
          colText: "成交单号",
          colShow: true
        },
        {
          colName: "HOUSEID",
          colText: "房源ID",
          colShow: false
        },
        {
          colName: "COMMUNITYNAME",
          colText: "小区名称",
          colShow: true
        },
        {
          colName: "BUILDING_NO",
          colText: "楼栋号",
          colShow: true
        },
        {
          colName: "UNIT_NO",
          colText: "单元",
          colShow: true
        },
        {
          colName: "HOUSE_NO",
          colText: "门牌号",
          colShow: true
        },
        {
          colName: "FLOOR",
          colText: "楼层",
          colShow: true
        },
        {
          colName: "DEAL_STATUS",
          colText: "成交状态",
          colShow: true
        },
        {
          colName: "DEAL_PRICE",
          colText: "实际成交价格（万元）",
          colShow: true
        },

        {
          colName: "DEPOSIT_AMOUNT",
          colText: "定金金额（元）",
          colShow: true
        },
        {
          colName: "DEPOSIT_DATE",
          colText: "定金支付日期",
          colShow: true
        },
        {
          colName: "BALANCE_AMOUNT",
          colText: "尾款金额（元）",
          colShow: true
        },
        {
          colName: "UTILITIESFEE",
          colText: "水电物业费",
          colShow: true
        },
        {
          colName: "OTHERFEE",
          colText: "其他费用",
          colShow: true
        },
        {
          colName: "ISPAYMENT",
          colText: "是否结算",
          colShow: true
        },
        {
          colName: "PAYMENTTM",
          colText: "尾款结算时间",
          colShow: true
        },
        {
          colName: "DEAL_DATETIME",
          colText: "签约时间",
          colShow: true
        },
        {
          colName: "AGENT_NAME",
          colText: "经纪人姓名",
          colShow: true
        },
        {
          colName: "AGENT_PHONE",
          colText: "经纪人电话",
          colShow: true
        },
        {
          colName: "AGENT_STORE",
          colText: "所属门店",
          colShow: true
        },
        {
          colName: "COMMISSION_AMOUNT",
          colText: "佣金金额",
          colShow: true
        },
        {
          colName: "COMMISSION_RATE",
          colText: "佣金比例百分比",
          colShow: true
        },
        {
          colName: "CASH_REWARD",
          colText: "现金奖结算金额",
          colShow: true
        },
        {
          colName: "COMMISSION_STATUS",
          colText: "结佣状态",
          colShow: true
        },
        {
          colName: "COMMISSION_DATE",
          colText: "结佣日期",
          colShow: true
        },
        {
          colName: "ISPAYMENT",
          colText: "是否结算尾款",
          colShow: true
        },
        {
          colName: "PAYMENTTM",
          colText: "打款时间",
          colShow: true
        },
        {
          colName: "REMARKS",
          colText: "打款摘要",
          colShow: true
        },
        {
          colName: "OWNER_NAME",
          colText: "业主姓名",
          colShow: true
        },
        {
          colName: "OWNER_PHONE",
          colText: "业主电话",
          colShow: true
        },
        {
          colName: "OWNER_ID_CARD",
          colText: "业主身份证",
          colShow: true
        },
        {
          colName: "HAS_KEY",
          colText: "是否收钥匙",
          colShow: false
        },
        {
          colName: "KEY_RECEIVE_DATE",
          colText: "收钥匙日期",
          colShow: false
        },
        {
          colName: "KEY_CANCEL_DATE",
          colText: "还钥匙日期",
          colShow: false
        },
        {
          colName: "REMARKS",
          colText: "备注",
          colShow: false
        },
        {
          colName: "CREATE_USER",
          colText: "创建人",
          colShow: true
        },
        {
          colName: "CREATE_TIME",
          colText: "创建时间",
          colShow: true
        },
        {
          colName: "UPDATE_USER",
          colText: "最后修改人",
          colShow: true
        },
        {
          colName: "UPDATE_TIME",
          colText: "最后修改时间",
          colShow: true
        },
        {
          colName: "IS_DELETE",
          colText: "是否删除：0未删除、1已删除",
          colShow: false
        },
        {
          colName: "PRIORITY_DISPLAY",
          colText: "优先展示：1优先展示、0普通展示",
          colShow: false
        },
        {
          colName: "COMMISSION_TYPE",
          colText: "佣金类型：1=固定金额(元)，2=百分比(%)",
          colShow: false
        },
        {
          colName: "COMMISSION_VALUE",
          colText: "佣金数值",
          colShow: true
        },
        {
          colName: "COMMISSION_REMARK",
          colText: "佣金备注",
          colShow: true
        },
        {
          colName: "CASH_REWARD",
          colText: "现金奖金额（元）",
          colShow: true
        },
        {
          colName: "DEPOSIT_VOUCHER_IMAGES",
          colText: "定金凭证图片列表",
          colShow: true
        },
        {
          colName: "COMMISSION_VOUCHER_IMAGES",
          colText: "佣金凭证图片列表",
          colShow: true
        },
        {
          colName: "BUDGET_AMOUNT",
          colText: "装修预算",
          colShow: true
        },
        {
          colName: "ACTUAL_COST",
          colText: "实际装修费用（元）",
          colShow: true
        }
      ],
      tableData: [],
      row: {},
      dialogVisible: false,
      // 结佣对话框
      commissionDialog: {
        visible: false,
        isView: false, // 是否为查看模式
        row: {}
      },
      // 经纪人佣金确认发放对话框
      commissionPayDialog: {
        visible: false,
        row: {}
      },
      // 房源尾款确认打款对话框
      finalPaymentDialog: {
        visible: false,
        row: {}
      },
      // 图片查看对话框
      imageDialog: {
        visible: false,
        title: "",
        images: []
      }
    };
  },
  created() {
    this.op = "adminHouseDealGl";
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.mainLoad();
  },
  methods: {
    // 格式化标准日期时间：智能判断是否显示时间部分
    // 如果服务端返回的是日期，则只显示 yyyy-MM-dd
    // 如果服务端返回的是日期时间，则显示 yyyy-MM-dd HH:mm:ss
    formatStandardDateTime(dateTimeStr) {
      if (!dateTimeStr) {
        return "";
      }

      const str = dateTimeStr.toString().trim();

      // 处理已格式化的日期时间字符串（包含 - 和 :）
      if (str.includes("-") && str.includes(":")) {
        // yyyy-MM-dd HH:mm:ss 格式，截取前19位
        if (str.length >= 19) {
          return str.substring(0, 19);
        }
        return str;
      }

      // 处理已格式化但只包含 - 的字符串（可能是 yyyy-MM-dd 或带空格的日期）
      if (str.includes("-") && !str.includes(":")) {
        // 如果包含空格，可能是 yyyy-MM-dd HH:mm:ss 但冒号丢失了，直接返回
        if (str.includes(" ")) {
          return str;
        }
        // 纯日期格式 yyyy-MM-dd
        if (str.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(str)) {
          return str;
        }
        return str;
      }

      // 处理纯数字格式（最常见的数据库格式）
      if (/^\d+$/.test(str)) {
        // yyyyMMddHHmmss 格式（14位或更多）- 包含时间
        if (str.length >= 14) {
          const year = str.substring(0, 4);
          const month = str.substring(4, 6);
          const day = str.substring(6, 8);
          const hour = str.substring(8, 10);
          const minute = str.substring(10, 12);
          const second = str.substring(12, 14);
          return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        }

        // yyyyMMdd 格式（8位）- 仅日期
        if (str.length === 8) {
          const year = str.substring(0, 4);
          const month = str.substring(4, 6);
          const day = str.substring(6, 8);
          return `${year}-${month}-${day}`;
        }
      }

      // 处理时间戳格式（13位毫秒或10位秒）
      if (/^\d{10,13}$/.test(str)) {
        const timestamp =
          str.length === 13 ? parseInt(str) : parseInt(str) * 1000;
        const date = new Date(timestamp);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hour = String(date.getHours()).padStart(2, "0");
          const minute = String(date.getMinutes()).padStart(2, "0");
          const second = String(date.getSeconds()).padStart(2, "0");
          return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        }
      }

      // 其他情况直接返回原值
      return str;
    },

    // 格式化日期时间：将yyyyMMdd和HHmmss转换为yyyy-MM-dd HH:mm:ss
    formatDateTime(dealDate, dealTime) {
      if (!dealDate || !dealTime) {
        return "";
      }

      // 处理日期部分 yyyyMMdd -> yyyy-MM-dd
      const year = dealDate.substring(0, 4);
      const month = dealDate.substring(4, 6);
      const day = dealDate.substring(6, 8);

      // 处理时间部分 HHmmss -> HH:mm:ss
      const hour = dealTime.substring(0, 2);
      const minute = dealTime.substring(2, 4);
      const second = dealTime.substring(4, 6);

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },

    // 计算尾款金额：DEAL_PRICE - DEPOSIT_AMOUNT
    calculateBalanceAmount(dealPrice, depositAmount) {
      // 如果没有成交价格，返回空
      if (!dealPrice || dealPrice === "" || dealPrice === "0") {
        return "";
      }

      // 将字符串转换为数字
      const price = parseFloat(dealPrice) * 10000;

      // 定金金额，如果为空则默认为0
      const deposit = depositAmount ? parseFloat(depositAmount) : 0;

      // 计算尾款金额
      const balance = price - deposit;
      // 格式化为两位小数
      return balance.toFixed(2);
    },

    // 获取图片数量
    getImageCount(imageStr) {
      if (!imageStr || imageStr === "[]" || imageStr === "") {
        return 0;
      }
      try {
        const images = JSON.parse(imageStr);
        return Array.isArray(images) ? images.length : 0;
      } catch (e) {
        return 0;
      }
    },

    // 解析图片数组
    parseImages(imageStr) {
      if (!imageStr || imageStr === "[]" || imageStr === "") {
        return [];
      }
      try {
        const images = JSON.parse(imageStr);
        return Array.isArray(images) ? images : [];
      } catch (e) {
        return [];
      }
    },

    // 打开图片查看对话框
    openImageDialog(imageStr, title) {
      this.imageDialog.title = title;
      this.imageDialog.images = [];

      if (!imageStr || imageStr === "[]" || imageStr === "") {
        this.imageDialog.visible = true;
        return;
      }

      try {
        const images = JSON.parse(imageStr);
        if (Array.isArray(images)) {
          this.imageDialog.images = images;
        }
      } catch (e) {
        console.error("解析图片数据失败:", e);
        this.$message.error("图片数据格式错误");
      }

      this.imageDialog.visible = true;
    },

    handleSelectionChange(val) {
      this.rows = val;
    },
    /**分页方法 开始 */
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    //加载主列表数据
    mainLoad() {
      //alert(JSON.stringify(this.pageSet));
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "mainLoad" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          this.isShowContent = false;
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
        this.isShowContent = true;
      });
    },
    roleBgHandler(row) {
      this.row = row;
      this.dialogVisible = true;
    },
    /**分页方法 结束 */

    // 打开结佣对话框
    openCommissionDialog(row) {
      this.commissionDialog.row = JSON.parse(JSON.stringify(row));
      this.commissionDialog.isView = row.COMMISSION_STATUS === "1"; // 已结佣则为查看模式
      this.commissionDialog.visible = true;

      // 如果没有结佣时间，自动填充当前时间
      if (!this.commissionDialog.row.COMMISSION_DATE) {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        this.commissionDialog.row.COMMISSION_DATE = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    },

    // 保存结佣信息
    saveCommission() {
      // 验证必填项
      if (
        !this.commissionDialog.row.COMMISSION_AMOUNT ||
        this.commissionDialog.row.COMMISSION_AMOUNT <= 0
      ) {
        alert("请输入有效的佣金金额");
        return;
      }

      if (!this.commissionDialog.row.COMMISSION_DATE) {
        alert("请选择结佣时间");
        return;
      }

      if (!confirm("确认提交结佣信息吗？")) {
        return;
      }

      var busData = {
        row: this.commissionDialog.row
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "updateCommission"
        },
        busData: busData
      };

      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.commissionDialog.visible = false;
          this.mainLoad(); // 刷新列表
        }
      });
    },

    // 打开经纪人佣金确认发放对话框
    openCommissionPayDialog(row) {
      this.commissionPayDialog.row = JSON.parse(JSON.stringify(row));
      this.commissionPayDialog.visible = true;
    },

    // 保存经纪人佣金确认发放
    saveCommissionPay() {
      // 验证必填项
      if (
        !this.commissionPayDialog.row.COMMISSION_AMOUNT ||
        this.commissionPayDialog.row.COMMISSION_AMOUNT <= 0
      ) {
        alert("请输入有效的佣金金额");
        return;
      }

      if (!confirm("确认发放佣金吗？")) {
        return;
      }

      var busData = {
        row: this.commissionPayDialog.row
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "confirmCommissionPay"
        },
        busData: busData
      };

      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.commissionPayDialog.visible = false;
          this.mainLoad(); // 刷新列表
        }
      });
    },

    // 打开房源尾款确认打款对话框
    openFinalPaymentDialog(row) {
      this.finalPaymentDialog.row = JSON.parse(JSON.stringify(row));
      this.finalPaymentDialog.visible = true;

      // 如果是否结算为已结算且没有结算时间，自动填充当前时间
      if (
        this.finalPaymentDialog.row.ISPAYMENT === "1" &&
        !this.finalPaymentDialog.row.PAYMENTTM
      ) {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        this.finalPaymentDialog.row.PAYMENTTM = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    },

    // 保存房源尾款确认打款
    saveFinalPayment() {
      // 验证必填项
      if (
        !this.finalPaymentDialog.row.DEAL_PRICE ||
        this.finalPaymentDialog.row.DEAL_PRICE <= 0
      ) {
        alert("请输入有效的成交价格");
        return;
      }

      if (
        !this.finalPaymentDialog.row.DEPOSIT_AMOUNT ||
        this.finalPaymentDialog.row.DEPOSIT_AMOUNT <= 0
      ) {
        alert("请输入有效的定金金额");
        return;
      }

      if (
        this.finalPaymentDialog.row.ISPAYMENT === "1" &&
        !this.finalPaymentDialog.row.PAYMENTTM
      ) {
        alert("请选择尾款结算时间");
        return;
      }

      if (!confirm("确认提交吗？")) {
        return;
      }

      var busData = {
        row: this.finalPaymentDialog.row
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "confirmFinalPayment"
        },
        busData: busData
      };

      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.finalPaymentDialog.visible = false;
          this.mainLoad(); // 刷新列表
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.trialScGlIndexClass {
  .addClassModel {
    padding-left: 15px;
    padding-right: 15px;
  }
  .trainSetClassMain .el-input {
    width: 60% !important;
  }
  .el-dialog {
    margin-top: 15px !important;
    width: 90%;
  }
  .searchMainClass .el-input {
    width: 150px !important;
  }
  .longLabelClass .el-input {
    width: 372px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }

  // 表格紧凑样式
  /deep/ .el-table {
    font-size: 13px !important;
  }
  /deep/ .el-table th.el-table__cell {
    padding: 6px 0 !important;
    background-color: #f5f7fa !important;
  }
  /deep/ .el-table td.el-table__cell {
    padding: 6px 0 !important;
  }
  /deep/ .el-table .cell {
    padding-left: 8px !important;
    padding-right: 8px !important;
    line-height: 20px !important;
  }
  /deep/ .el-button--text {
    padding: 0 !important;
    font-size: 13px !important;
  }
  .mainDivJd {
    .el-progress-bar__innerText {
      color: #f300ff !important;
    }
  }

  .fzrsMainDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .dwInfoDivId {
    .el-form-item__content {
      float: left;
    }
  }
  /deep/ .el-dialog {
    margin-top: 15px !important;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sfOrderGlIndex/SfOrderGlIndex.vue